var generateStyle = function generateStyle(componentTheme) {
  return {
    sessionItemResultsListHeaderWrapper: {
      textAlign: 'left',
      margin: "".concat(componentTheme.sessionItemResultsListHeaderWrapperMarginTopBottom, " ").concat(componentTheme.sessionItemResultsListHeaderWrapperMarginLeftRight)
    },
    sessionItemResultsListHeader: {
      fontSize: componentTheme.sessionItemResultsListHeaderFontSize
    },
    sessionItemResultsList: {
      marginTop: componentTheme.sessionItemResultsListMargin,
      borderBottom: "solid ".concat(componentTheme.sessionItemResultsListBorderWidth, " ").concat(componentTheme.sessionItemResultsListBorderColor)
    }
  };
};
export default generateStyle;